import React from 'react';

import Pagination from '../../../components/Pagination';
import NotificationListItem, { IPropsNotificationListItem } from '../components/NotificationListItem';

interface IPropsNotificationListTablePresenter {
  currentPage: number;
  pageLimit?: number;
  totalCount?: number;
  notificationLists?: IPropsNotificationListItem[];
  onChangePage: (page: number) => void;
  onDelete: (notiId: string) => void;
}

const PAGE_LIMIT = 10;

const NotificationListTablePresenter = ({ notificationLists, pageLimit, totalCount, currentPage, onChangePage, onDelete }: IPropsNotificationListTablePresenter) => {
  return (
    <div className="overflow-x-auto overflow-y-hidden">
      <table className="table w-full">
        <thead>
          <tr>
            <th>Title</th>
            <td>Description</td>
            <th>Url</th>
            <td>Noti Date / Time</td>
            <td>Notified</td>
            <td>Type</td>
            <td>Platforms</td>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {notificationLists?.map((noti) => (
            <NotificationListItem {...noti} key={noti._id} onDelete={() => onDelete(noti._id)} />
          ))}
        </tbody>
      </table>

      <div className="flex items-center justify-between mt-12">
        <span className="text-systemGrays02LabelSecondary">แสดงผล {PAGE_LIMIT} รายการต่อหน้า</span>

        {(totalCount || 0) > 0 && <Pagination currentPage={currentPage} totalCount={totalCount || 0} pageSize={pageLimit || PAGE_LIMIT} onPageChange={onChangePage} />}
      </div>
    </div>
  );
};

export default NotificationListTablePresenter;
